"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var orderListApi = _interopRequireWildcard(require("@/api/orderListApi.js"));
var aftersaleApi = _interopRequireWildcard(require("@/api/aftersaleApi"));
var _validate = require("@/utils/validate");
var _logisticsTrackingNo = require("@/utils/logisticsTrackingNo");
var _sendCompany = _interopRequireDefault(require("./sendCompany.vue"));
var _skuSend = _interopRequireDefault(require("../components/skuSend.vue"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var cache;
function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var r, c, a = Object.defineProperty, n = { __proto__: null, default: e }; if (Object(e) !== e) return n; if (cache || "function" != typeof WeakMap || (cache = new WeakMap()), cache) { if (cache.has(e)) return cache.get(e); cache.set(e, n); } for (c in e) "default" !== c && {}.hasOwnProperty.call(e, c) && ((r = a && Object.getOwnPropertyDescriptor(e, c)) && (r.get || r.set) ? a(n, c, r) : n[c] = e[c]); return n; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {
    SendCompany: _sendCompany.default,
    SkuSend: _skuSend.default
  },
  props: {
    formType: {
      type: [String, Number],
      default: 1 // 1: 订单发货 2: 售后发货
    },
    showCompany: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    submitDisabled: function submitDisabled() {
      if (!this.showCompany) {
        return false;
      }
      if (this.activeName == 1) {
        return this.sendLists.some(function (item) {
          return !!item.transportNo && !item.companyValue;
        });
      }
      return this.splitSubmitDisabled;
    }
  },
  data: function data() {
    return {
      visible: false,
      loading: false,
      details: {},
      // 预留一份数据
      sendLists: [{
        transportNo: null,
        companyValue: null
      }],
      baseSubmit: {},
      // 基础提交信息
      activeName: '1',
      detailInfo: {},
      // 详情
      itemLists: [],
      splitSubmitDisabled: false
    };
  },
  mounted: function mounted() {},
  methods: {
    normalizeSendItem: function normalizeSendItem() {
      var item = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return _objectSpread(_objectSpread({}, item), {}, {
        transportNo: (0, _logisticsTrackingNo.normalizeLogisticsTrackingNo)(item.transportNo)
      });
    },
    hasCompleteSendInfo: function hasCompleteSendInfo() {
      var item = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var hasTransportNo = !!item.transportNo;
      var hasCompany = this.showCompany ? !!item.companyValue : true;
      var hasOrderItems = this.activeName == 2 ? !!item.orderItemIds : true;
      return hasTransportNo && hasCompany && hasOrderItems;
    },
    handleSplitSubmitDisabledChange: function handleSplitSubmitDisabledChange(disabled) {
      this.splitSubmitDisabled = !!disabled;
    },
    openInit: function () {
      var _openInit = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var _this = this;
        var baseSubmit,
          _args = arguments;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              baseSubmit = _args.length > 0 && _args[0] !== undefined ? _args[0] : {};
              this.baseSubmit = baseSubmit;
              this.details = {};
              this.sendLists = [{
                transportNo: null,
                companyValue: null
              }];
              this.splitSubmitDisabled = false;
              if (this.formType == 1 && baseSubmit.orderNo) {
                this.getSkuList(baseSubmit.orderNo);
                orderListApi.getSendInfo(baseSubmit.orderNo).then(function (res) {
                  var _ref = res || {},
                    _ref$deliveryList = _ref.deliveryList,
                    deliveryList = _ref$deliveryList === void 0 ? [] : _ref$deliveryList,
                    type = _ref.type;
                  _this.activeName = type ? String(type) : '1';
                  _this.visible = true;
                  if (type == 1) {
                    _this.sendLists = deliveryList.length ? deliveryList.map(function (item) {
                      return {
                        transportNo: item.deliveryNo,
                        companyValue: item.deliveryId,
                        initSearch: item.deliveryName,
                        deliveryCode: item.deliveryCode,
                        deliveryName: item.deliveryName
                      };
                    }) : [{
                      transportNo: null,
                      companyValue: null
                    }];
                  } else {
                    _this.sendLists = deliveryList.map(function (item) {
                      return _objectSpread(_objectSpread({}, item), {}, {
                        transportNo: item.deliveryNo,
                        companyValue: item.deliveryId,
                        initSearch: item.deliveryName,
                        deliveryName: item.deliveryName,
                        deliveryCode: item.deliveryCode
                      });
                    });
                  }
                }).catch(function (err) {
                  _this.visible = true;
                });
              } else if (this.formType == 2 && baseSubmit.id) {
                // getRefundDelivery
                aftersaleApi.getRefundDelivery(baseSubmit.id).then(function (res) {
                  _this.visible = true;
                  _this.sendLists = res.length ? res.map(function (item) {
                    return {
                      transportNo: item.logisticsNo
                    };
                  }) : [{
                    transportNo: null
                  }];
                }).catch(function (err) {
                  _this.visible = true;
                });
              } else {
                this.visible = true;
              }
            case 1:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function openInit() {
        return _openInit.apply(this, arguments);
      }
      return openInit;
    }(),
    handerSubmit: (0, _validate.Debounce)(function (form) {
      var _this2 = this;
      var sendLists = this.activeName == 1 ? this.sendLists : this.$refs['skuSendRef'].handerSubmit();
      sendLists = sendLists.length ? sendLists.map(function (item) {
        return _this2.normalizeSendItem(item);
      }) : [];
      if (this.activeName == 1) {
        this.sendLists = sendLists;
      }
      var invalidTransportResult = sendLists.filter(function (item) {
        return item.transportNo;
      }).map(function (item) {
        return {
          item: item,
          result: (0, _logisticsTrackingNo.validateLogisticsTrackingNo)(item)
        };
      }).find(function (_ref2) {
        var result = _ref2.result;
        return !result.valid;
      });
      if (invalidTransportResult) {
        this.$message.warning(invalidTransportResult.result.message);
        return;
      }
      var sends = sendLists.length && sendLists.filter(function (item) {
        return _this2.hasCompleteSendInfo(item);
      }) || [];
      if (!sends.length) {
        this.$message.warning('请至少填写一项完整物流信息（需包含物流公司、物流单号）！');
        return;
      }
      ;
      var sendMap = {
        1: {
          methodName: 'sendOrder',
          datas: _objectSpread(_objectSpread({}, this.baseSubmit), {}, {
            type: this.activeName * 1,
            orderShipmentsRequestList: sends.map(function (item) {
              var _ref3 = item || {},
                companyValue = _ref3.companyValue,
                transportNo = _ref3.transportNo,
                orderItemIds = _ref3.orderItemIds;
              var objs = {
                deliveryId: companyValue,
                deliveryNo: transportNo
              };
              if (_this2.activeName == 2) {
                objs['orderItemIds'] = orderItemIds;
              }
              return objs;
            })
          })
        },
        2: {
          methodName: 'sendAftersale',
          datas: _objectSpread(_objectSpread({}, this.baseSubmit), {}, {
            logisticsInfos: sends.map(function (item) {
              return {
                // deliveryId: item.companyValue,
                logisticsNo: item.transportNo
              };
            })
          })
        }
      };
      var sendInfo = sendMap[this.formType] || {};
      if (!sendInfo.methodName) return;
      this.loading = true;
      orderListApi[sendInfo.methodName](sendInfo.datas).then(function (data) {
        _this2.$message.success('操作成功');
        _this2.loading = false;
        _this2.visible = false;
        _this2.$emit('doRefresh');
      }).catch(function () {
        _this2.loading = false;
      });
    }),
    closeEdit: function closeEdit() {
      this.visible = false;
    },
    getSkuList: function getSkuList(orderNo) {
      var _this3 = this;
      this.itemLists = [];
      orderListApi.getSkuSendList2(orderNo).then(function (res) {
        _this3.itemLists = res || [];
      });
    },
    // 删除
    removeCompany: function removeCompany(i) {
      this.sendLists.splice(i, 1);
    }
  }
};